import type Dialog from '@naturehouse/design-system/components/molecules/dialog/Dialog';
import { DialogEvents } from '@naturehouse/design-system/components/molecules/dialog/Dialog';
import type { SortByValue } from './ReviewListItems';
import ReviewListItems from './ReviewListItems';
import ReviewListManager from './ReviewListManager';
import ReviewPaginationHandler from './ReviewPaginationHandler';
import GTM from '../../../../gtm/GTM';
import GTMDetailSortReviewsChangeModel from '../../../../gtm/models/GTMDetailSortReviewsChangeModel';

export default class ReviewDialogSortHandler {
    public initialize(dialog: Dialog): void {
        const reviewListItems = ReviewListItems.getInstance();
        ReviewPaginationHandler.getInstance();
        const reviewListManager = ReviewListManager.getInstance();

        dialog.addEventListener(DialogEvents.OPENED, (): void => {
            const sortSelect = dialog.querySelector<HTMLSelectElement>(
                '[data-role="reviews-sort"]'
            );

            if (!sortSelect) {
                return;
            }

            if (sortSelect.dataset.sortListenerAttached) {
                reviewListItems.goToPage(1);
                sortSelect.value = 'newest';
                reviewListItems.sortBy = 'newest' as SortByValue;
                reviewListManager.scrollToFirstReview('auto');
                return;
            }

            reviewListManager.render();
            sortSelect.dataset.sortListenerAttached = 'true';

            sortSelect.addEventListener('change', () => {
                const container = dialog.querySelector<HTMLElement>(
                    '[data-role="reviews-container"]'
                );

                container?.setAttribute('data-loading', '');
                reviewListItems.sortBy = sortSelect.value as SortByValue;

                GTM.track(
                    GTMDetailSortReviewsChangeModel.parseToGTMData({
                        sortBy: reviewListItems.sortBy
                    })
                );
            });
        });
    }
}
